/**
 * Utility functions for handling links in text content
 */

// Regular expression to match URLs
const URL_REGEX = /(https?:\/\/[^\s]+)/g;

/**
 * Converts URLs in text to clickable "Event Link" components
 * @param {string} text - The text content that may contain URLs
 * @returns {Array} - Array of text and link components
 */
export function formatTextWithLinks(text) {
  if (!text) return [text];
  
  const parts = [];
  let lastIndex = 0;
  let match;
  
  while ((match = URL_REGEX.exec(text)) !== null) {
    // Add text before the URL
    if (match.index > lastIndex) {
      parts.push(text.slice(lastIndex, match.index));
    }
    
    // Add the URL as a link component
    parts.push({
      type: 'link',
      url: match[0],
      key: `link-${match.index}`
    });
    
    lastIndex = match.index + match[0].length;
  }
  
  // Add remaining text after the last URL
  if (lastIndex < text.length) {
    parts.push(text.slice(lastIndex));
  }
  
  return parts.length > 0 ? parts : [text];
}

/**
 * Check if text contains any URLs
 * @param {string} text - The text to check
 * @returns {boolean} - True if text contains URLs
 */
export function hasLinks(text) {
  if (!text) return false;
  return URL_REGEX.test(text);
}